export const getLabelStyle = (theme) => (Object.assign({}, theme.typography.labelMedium));
export const getBoldStyle = (theme) => (Object.assign(Object.assign({}, theme.typography.titleMedium), { fontFamily: theme.typography.fontFamily }));
